import { Field } from '@k2/common/k2-forms-state/types';
import { TelephonePipe } from '@k2/common/telephone/pipes/telephone.pipe';

export function telephoneFormatter(telephonePipe: TelephonePipe, field: Field): string {
  return telephonePipe.transform(field.control.value);
}
